module.exports = __webpack_public_path__ + "img/jed_and_octavius.4be8f15a.jpg";